// import axios from 'axios';
// import { getBaseApiUrl } from '@/utility/utility';

// interface OrderLineInterface {
//   Line_No: number;
//   Line_Notes: string;
//   Product_URL: string;
// }

// interface OrderLineModerationInterface {
//   id: number;
//   sku: string;
//   name: string;
//   barcode: string;
//   qty: number;
//   recipe: string;
// }

// interface ModerationInteface {
//   email: string;
//   token: string;
//   order_id: string;
//   order_reference: string;
//   order_date: string;
//   order_courier: string;
//   delivery_contact: string;
//   delivery_address_1: string;
//   delivery_address_2: string;
//   delivery_town: string;
//   delivery_county: string;
//   delivery_postcode: string;
//   delivery_country_code: string;
//   delivery_phone: string;
//   delivery_email: string;
// }

// const BASE = `${getBaseApiUrl()}/orders`;
// axios.defaults.withCredentials = true;

// const OrdersServices = {
// fetch({ email = '', token = '' }: { email: string; token: string }): Promise<any> {
//   const URL = `${BASE}/fetch`;
//   return axios.post(URL, { data: { email, token } }, { withCredentials: true });
// },
//   splitLine({
//     email = '',
//     token = '',
//     orderNo = '',
//     lineNo = '',
//     qty = '0',
//   }: {
//     email: string;
//     token: string;
//     orderNo: string;
//     lineNo: string;
//     qty: string;
//   }): Promise<any> {
//     const URL = `${BASE}/splitLine`;
//     return axios.post(URL, { data: { email, token, orderNo, lineNo, qty } }, { withCredentials: true });
//   },
//   updateOrder({
//     email = '',
//     token = '',
//     orderNo = '',
//     lines = [],
//   }: {
//     email: string;
//     token: string;
//     orderNo: string;
//     lines: Array<OrderLineInterface>;
//   }): Promise<any> {
//     const URL = `${BASE}/updateOrder`;
//     return axios.post(URL, { data: { email, token, orderNo, lines: [...lines] } }, { withCredentials: true });
//   },
//   moderate({
//     data = {
//       email: '',
//       token: '',
//       order_id: '',
//       order_reference: '',
//       order_date: '',
//       order_courier: '',
//       delivery_contact: '',
//       delivery_address_1: '',
//       delivery_address_2: '',
//       delivery_town: '',
//       delivery_county: '',
//       delivery_postcode: '',
//       delivery_country_code: '',
//       delivery_phone: '',
//       delivery_email: '',
//     },
//     order_lines = [],
//   }: {
//     data: ModerationInteface;
//     order_lines: Array<OrderLineModerationInterface>;
//     orderNo: string;
//     lines: Array<OrderLineInterface>;
//   }): Promise<any> {
//     const URL = `${BASE}/updateOrder`;
//     return axios.post(URL, { data: { ...data, order_lines: [...order_lines] } }, { withCredentials: true });
//   },
// };

// export default OrdersServices;

// WORKING COPY ABOVE!!

// STUB BELOW
import axios from 'axios';
// import { getBaseApiUrl } from '@/utility/utility';

interface OrderLineInterface {
  Line_No: number;
  Line_Notes: string;
  Product_URL: string;
}

// const BASE = `${getBaseApiUrl()}/orders`;
const BASE = '/api/v1.0/orders';

// axios.defaults.withCredentials = true;

const OrdersServices = {
  fetch({ orderNo }: { orderNo: string }): Promise<any> {
    return axios.post(`${BASE}/fetch`, { data: { orderNo } });
  },
  // STUB
  // fetch(): Promise<any> {
  //   return axios.get('./orders.json', {
  //     headers: {
  //       'Cache-Control': 'no-cache',
  //       Pragma: 'no-cache',
  //       Expires: '0',
  //     },
  //   });
  // },
  splitLine({ orderNo = '', lineNo = '', qty = '0' }: { orderNo: string; lineNo: string; qty: string }): Promise<any> {
    const URL = `${BASE}/splitLine`;
    return axios.post(URL, { data: { orderNo, lineNo, qty } }, { withCredentials: true });
  },
  // updateOrder({
  //   email = '',
  //   token = '',
  //   orderNo = '',
  //   lines = [],
  // }: {
  //   email: string;
  //   token: string;
  //   orderNo: string;
  //   lines: Array<OrderLineInterface>;
  // }): Promise<any> {
  //   const URL = `${BASE}/updateOrder`;
  //   return axios.post(URL, { data: { email, token, orderNo, lines: [...lines] } }, { withCredentials: true });
  // },
  updateOrder({ orderNo = '', lines = [] }: { orderNo: string; lines: Array<OrderLineInterface> }): Promise<any> {
    const URL = `${BASE}/updateOrder`;
    return axios.post(URL, { data: { orderNo, lines: [...lines] } }, { withCredentials: true });
  },
  removeLine({
    orderNo = '',
    lineNo = '',
    extNo = '',
  }: {
    orderNo: string;
    lineNo: string;
    extNo: string;
  }): Promise<any> {
    const URL = `${BASE}/removeLine`;
    return axios.post(URL, { data: { orderNo, lineNo, extNo } }, { withCredentials: true });
  },
  applyRecipe({
    orderNo = '',
    recipeID,
    productID,
  }: {
    orderNo: string;
    recipeID: string;
    productID: string;
  }): Promise<any> {
    return axios.post(`${BASE}/applyRecipe`, { data: { orderNo, recipeID, productID } });
  },
  moderate({ orderNo = '', email = '' }: { orderNo: string; email: string | number }): Promise<any> {
    const URL = `${BASE}/moderate`;
    return axios.post(URL, { data: { orderNo, email } }, { withCredentials: true });
  },
};

export default OrdersServices;
